import { usePlanStatus } from 'src/hooks/usePlanStatusHook';

export const SINGLE_COMPANY_PER_CLIENT = 1;

// The two multi-company surfaces derive their Classic limit from different
// sources (CRM permissions, Stripe price rules), so the Studio rule lives here
// to keep them from disagreeing. Clamping to one company mirrors a Classic
// Starter limit, which is what lets the existing at-limit copy and upgrade
// tooltip carry the locked state unchanged.
export const useMaxCompaniesPerClient = (classicLimit: number): number => {
  const { studio } = usePlanStatus();

  return studio.isStudioPricingWorkspace &&
    !studio.hasFeatureAccess('multiCompanyClients')
    ? SINGLE_COMPANY_PER_CLIENT
    : classicLimit;
};
